import { createAsyncThunk } from "@reduxjs/toolkit";

import { createRegistrations } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";
import { OptionalTokenParams } from "./../../../types/optional-token-params";

type AdditionalParams = {
  confirmation_token?: string;
  verification_code?: string;
};

const buildAdditionalParams = (
  params: OptionalTokenParams
): AdditionalParams => {
  if (!params.token) return {};

  return { [params.type]: params.token };
};

export const saveRegistrations = createAsyncThunk(
  "registrations/saveRegistrations",
  async (params: OptionalTokenParams, { getState, rejectWithValue }) => {
    try {
      const { adapter, questions, recaptcha } = getState() as AppState;
      const baseUrl = adapter?.adapter?.baseUrl;
      const { token } = fetchAuthToken(getState());
      const { answers } = questions;
      const { recaptchaToken } = recaptcha;
      const recaptchaParam = recaptchaToken && {
        gRecaptchaResponse: recaptchaToken
      };
      const additionalParams = buildAdditionalParams(params);

      const response = await createRegistrations(
        token,
        baseUrl,
        {
          signupFormResponse: answers,
          ...recaptchaParam
        },
        additionalParams
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
